import { roundNumberToTwoDecimals, BarChartTooltipItem } from '@occc/ui-design-system';
import { separateEveryThousandByComma } from '../../../../lib/numbers';

type BuildBarChartTooltipSurveyRangedItemsType = {
  range: string;
  sum: number;
  percentage: number;
};

export const buildBarChartTooltipSurveyRangedItems = ({
  range,
  sum,
  percentage,
}: BuildBarChartTooltipSurveyRangedItemsType): BarChartTooltipItem[] => {
  return [
    {
      label: 'Responses in',
      value: range,
    },
    {
      label: 'Number of responses',
      value: typeof sum === 'number' ? separateEveryThousandByComma(sum) : '',
    },
    {
      label: 'Selected cohort size',
      value: `${roundNumberToTwoDecimals(percentage)}%`,
    },
  ];
};
